import { render, staticRenderFns } from "./vipConfiguration.vue?vue&type=template&id=445f5762&scoped=true"
import script from "./vipConfiguration.vue?vue&type=script&lang=js"
export * from "./vipConfiguration.vue?vue&type=script&lang=js"
import style0 from "./vipConfiguration.vue?vue&type=style&index=0&id=445f5762&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445f5762",
  null
  
)

export default component.exports